import { Server, NewsServer } from "../API";

import {
  CURRENCY,
  CURRENCY_FAILURE,
  CURRENCY_DETAILS,
  CURRENCY_DETAILS_FAILURE,
  NEWS,
  NEWS_FAILURE,
  COIN_HISTORY,
  COIN_HISTORY_FAILURE,
  CLEAR_STATUS,
  RESET_STATE,
  SET_TAB,
} from "./Types";

// Secured Combined Catches
// import { HandleExceptionWithSecureCatch } from "./CombinedCatch";

const ResetState = () => {
  return {
    type: RESET_STATE,
    payload: null,
  };
};

const ClearLogs = () => {
  return {
    type: CLEAR_STATUS,
    payload: null,
  };
};

const getCurrency = (count) => {
  return async (dispatch) => {
    try {
      const response = await Server.get(`/coins?limit=${count}`);
      dispatch({
        type: CURRENCY,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: CURRENCY_FAILURE,
        payload: e.response?.status,
      });
    }
  };
};

const getNews = (newsCategory, count) => {
  return async (dispatch) => {
    try {
      const response = await NewsServer.get(
        `/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`
      );
      dispatch({
        type: NEWS,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: NEWS_FAILURE,
        payload: e.response?.status,
      });
    }
  };
};

const getCoinHistory = (coinId, timeperiod) => {
  return async (dispatch) => {
    try {
      const response = await Server.get(
        `coin/${coinId}/history?timeperiod=${timeperiod}`
      );
      dispatch({
        type: COIN_HISTORY,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: COIN_HISTORY_FAILURE,
        payload: e.response?.status,
      });
    }
  };
};

const getCurrencyDetail = (coinId) => {
  return async (dispatch) => {
    try {
      const response = await Server.get(`/coin/${coinId}`);
      dispatch({
        type: CURRENCY_DETAILS,
        payload: response.data,
      });
    } catch (e) {
      dispatch({
        type: CURRENCY_DETAILS_FAILURE,
        payload: e.response?.status,
      });
    }
  };
};

const NavTab = (tab) => {
  return (dispatch) => {
    dispatch({
      type: SET_TAB,
      payload: tab,
    });
  };
};

export {
  ResetState,
  ClearLogs,
  getCurrency,
  getNews,
  getCoinHistory,
  getCurrencyDetail,
  NavTab,
};
